const breakpoints = {
  values: {
    xs: 0,
    sm: 475,
    md: 725,
    lg: 1024,
    xl: 1440,
  },
};

export { breakpoints };
